export default __webpack_public_path__ + "static/media/chat.f4acf88a.svg";